
import {
  defineComponent, inject, Ref, ref,
} from 'vue';
import { defineRule, Form } from 'vee-validate';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '@/store/mainStore';
import AppHeader from '@/components/AppHeader.vue';
import AppInput from '@/components/UI/AppInput.vue';
import AppButton from '@/components/UI/AppButton.vue';
import { ICredentials } from '@/types/interfaces';
// eslint-disable-next-line import/no-cycle
import AuthService from '@/modules/auth/services/AuthService';
import ValidationService from '@/services/ValidationService';
import { PASSWORD_LENGTH } from '@/types/consts';
// eslint-disable-next-line import/no-cycle
import router from '@/router';
import LocalStorageService from '@/services/LocalStorageService';
import AppAlert from '@/components/UI/AppAlert.vue';
import DesktopHeader from '@/components/desktop/DesktopHeader.vue';
import DriveAsideMainMenu from '@/modules/drive/components/desktop/DriveAsideMainMenu.vue';

// defineRule('required', (value:string) => ValidationService.isNotEmpty(value) || 'This field is required');
// defineRule('confirmed', (value, params, ctx) => {
//   if (value === ctx.form[params[0]]) return true;
//   return 'Password not match';
// });

export default defineComponent({
  components: {
    DriveAsideMainMenu,
    DesktopHeader,
    AppHeader,
    AppInput,
    AppButton,
    AppAlert,
    Form,
  },
  setup() {
    const schema = {
      password: 'required',
      newPassword: 'required', // |min6|special|capital|numeric
      confirmation: 'required', // |confirmed:newPassword
    };
    const errorKey: Ref<string> = ref('');
    const currentPasswordValue = ref<string>('');
    const errorNewPassword = ref('');
    const errorConfirmPassword = ref('');
    const errorCurrentPassword = ref('');
    const mainStore = useMainStore();
    // eslint-disable-next-line @typescript-eslint/ban-types
    const $localize = inject('$localize') as Function;

    function onBeforeSubmit(values) {
      // confirmation, newPassword, password
      if (!ValidationService.containsSpecialCharacter(values.password)) {
        errorCurrentPassword.value = 'Password is not matching';
        return false;
      }
      if (!ValidationService.isLonger(values.password, 6)) {
        errorCurrentPassword.value = 'Password is not matching';
        return false;
      }
      if (!ValidationService.containsCapitalLetter(values.password)) {
        errorCurrentPassword.value = 'Password is not matching';
        return false;
      }
      if (!ValidationService.containsNumeric(values.password)) {
        errorCurrentPassword.value = 'Password is not matching';
        return false;
      }
      // if (!ValidationService.containsSpecialCharacter(values.password)) {
      //   errorCurrentPassword.value = 'Password is not valid, should contain: 1 special character';
      //   return false;
      // }
      if (!ValidationService.containsSpecialCharacter(values.newPassword)) {
        errorNewPassword.value = 'Password is not valid, should contain: 1 special character';
        return false;
      }
      if (!ValidationService.isLonger(values.newPassword, 6)) {
        errorNewPassword.value = 'Password is not valid, should be not less then 6 characters';
        return false;
      }
      if (!ValidationService.containsCapitalLetter(values.newPassword)) {
        errorNewPassword.value = 'Password is not valid, should contain: 1 uppercase letter';
        return false;
      }
      if (!ValidationService.containsNumeric(values.newPassword)) {
        errorNewPassword.value = 'Password is not valid, should contain: 1 number';
        return false;
      }
      if (values.confirmation !== values.newPassword) {
        errorConfirmPassword.value = 'Password Mismatch';
        return false;
      }
      return true;
    }

    function onSubmit(values) {
      const isFormValid = onBeforeSubmit(values);
      if (!isFormValid) return;
      errorKey.value = '';
      const payload = {
        lastPassword: values.password,
        password: values.newPassword,
      };
      AuthService.changeOldPassword(payload).then((response) => {
        if (response.success) {
          LocalStorageService.setAuthToken(response.results.authToken);
          router.push('/settings');
        } else {
          errorKey.value = response.errorKey ? $localize('settings.change.password.submit.mismatch') : '';
        }
      });
    }
    return {
      schema,
      errorKey,
      errorConfirmPassword,
      currentPasswordValue,
      errorNewPassword,
      errorCurrentPassword,
      onSubmit,
      mainStore,
    };
  },
});
